module.exports = __webpack_public_path__ + "img/user-graduate.fc010bc5.svg";